module.exports = __webpack_public_path__ + "static/14-c3b0250246f11b59d2e79cd6ae28ea0f.jpg";